
export default class RegionModel {
    id: number;
    name: string;
    description: string;
    status: string;
    type: string;
    typeCaption: string;
    zipcode: number;
    code: string;
    latitude: number;
    longitude: number;
    elevation: number;
    parent: any;
    parentCaption: string;
    regionLength: number;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.type = datarow.type || 'village';
        this.typeCaption = RegionModel.optionType.filter((d: any) => d.name === this.type)?.[0]?.caption || 'Village';
        this.zipcode = datarow.zipcode;
        this.code = datarow.code;
        this.latitude = datarow.latitude;
        this.longitude = datarow.longitude;
        this.elevation = datarow.elevation;
        let parent= datarow.parent?.data? new RegionModel(datarow.parent?.data) : datarow.parent;
        this.parent= parent?.id;
        this.parentCaption = parent?.name; 
        let region= datarow.region?.data? new RegionModel(datarow.region?.data) : datarow.region;
        this.regionLength = region?.length || 0;
    } 

    public static endPoint: string = 'regions';
    public static endPointFilterList = (parentId?: number, type?: string) => {
        return ( '?populate=*&sort=name' +
            (type? '&filters[type]=' + type :
            '&filters[parent]' + (parentId? '=' + parentId : '[id][$null]=true')
            )
        );
    }
    public static url: string = '/region';
    public static caption: string = 'Region';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        type: 'village',
        typeCaption: 'Village',
        zipcode:  0,
        code:  '',
        latitude:  0,
        longitude:  0,
        elevation: 0,     
        parent: null,
        parentCaption: '',
        regionLength: 0,  
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'province', caption: 'Propinsi' },
        { name: 'city', caption: 'Kota/Kabupaten' },
        { name: 'subdistrict', caption: 'Kecamatan' },
        { name: 'village', caption: 'Kelurahan/Desa' },
    ]
}